import { useState } from 'react';
import { PRODUCTS } from '../constants/content';

export default function Products({ onSelect }) {
  const [active, setActive] = useState(PRODUCTS[0].id);

  function handleSelect(product) {
    setActive(product.id);
    onSelect?.(product);
  }

  return (
    <section className="fm-section" id="products">
      <div className="fm-container">
        <div className="fm-sec-head">
          <p className="fm-kicker">Software</p>
          <h2 className="fm-sec-title">Popular software suites</h2>
          <p className="fm-sec-lead">
            Choose the creative or marketing suite that fits your workflow, then
            pick a seat plan that matches your team.
          </p>
        </div>

        <div className="fm-product-grid">
          {PRODUCTS.map((product) => (
            <button
              key={product.id}
              type="button"
              className={`fm-product${active === product.id ? ' is-active' : ''}`}
              onClick={() => handleSelect(product)}
            >
              <div className="fm-product__top">
                <p className="fm-product__cat">{product.category}</p>
                {product.badge && (
                  <span className="fm-product__badge">{product.badge}</span>
                )}
              </div>
              <h3>{product.name}</h3>
              <p>{product.blurb}</p>
              <div className="fm-product__foot">
                <p className="fm-product__price">
                  ${product.price}
                  <span> / seat</span>
                </p>
                <span className="fm-btn fm-btn--outline fm-btn--sm">Select</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
